/**
 * Excel ile bayi bazlı duyuru.
 * Spec: indexpazar-backend/docs/superpowers/specs/2026-09-07-excel-ile-bayi-bazli-duyuru-design.md
 */

/** Popup'ın bayiye kaç kez gösterileceği. */
export enum ExcelAnnouncementRepeatMode {
  Once = 1,
  PerLogin = 2,
  PerVisit = 3,
  Daily = 4,
}

/** Aynı bayinin birden fazla satırı varsa popup'ın sunum biçimi. */
export enum ExcelAnnouncementGroupMode {
  Separate = 1,
  Combined = 2,
}

/** Opsiyonel tek resmin açıklamaya göre konumu. */
export enum ExcelAnnouncementImagePosition {
  Above = 1,
  Below = 2,
}

/** Çözümlenmiş satırların gruplama boyutu. */
export enum ExcelAnnouncementRowGroupBy {
  Announcement = 1,
  File = 2,
  Dealer = 3,
}

export const repeatModeOptions = [
  { value: ExcelAnnouncementRepeatMode.Once, label: 'Bir kez gösterilsin (kapatınca bitsin)' },
  { value: ExcelAnnouncementRepeatMode.PerLogin, label: 'Her login olduğunda' },
  { value: ExcelAnnouncementRepeatMode.PerVisit, label: 'Her ana sayfa ziyaretinde' },
  { value: ExcelAnnouncementRepeatMode.Daily, label: 'Günde 1 kere' },
]

export const groupModeOptions = [
  { value: ExcelAnnouncementGroupMode.Separate, label: 'Her satır ayrı popup' },
  { value: ExcelAnnouncementGroupMode.Combined, label: 'Tek popup, satırlar alt alta' },
]

export const imagePositionOptions = [
  { value: ExcelAnnouncementImagePosition.Above, label: 'Açıklamanın üstünde' },
  { value: ExcelAnnouncementImagePosition.Below, label: 'Açıklamanın altında' },
]

export const groupByOptions = [
  { value: ExcelAnnouncementRowGroupBy.Announcement, label: 'Duyuru bazlı' },
  { value: ExcelAnnouncementRowGroupBy.File, label: 'Excel bazlı' },
  { value: ExcelAnnouncementRowGroupBy.Dealer, label: 'Bayi bazlı' },
]

export interface IUploadFile {
  Label: string
  Content: string
  Extension: string
  FileType: string
}

export interface IExcelAnnouncementSaveRequest {
  Id: number
  Topic: string
  DescriptionTemplate: string
  StartDate: Date | string
  EndDate: Date | string
  Enable: boolean
  RepeatMode: ExcelAnnouncementRepeatMode
  GroupMode: ExcelAnnouncementGroupMode
  ImagePosition: ExcelAnnouncementImagePosition
  Image?: IUploadFile | null
  RemoveImage?: boolean
  Excel?: IUploadFile | null
  HasHeaderRow: boolean
  /** Popup'ın altında bayinin kendi teminat mektupları listelensin mi. */
  ShowGuaranteeLetters: boolean
}

export interface IExcelAnnouncementFileAddRequest {
  AnnouncementId: number
  Excel: IUploadFile
  HasHeaderRow: boolean
}

export interface IExcelAnnouncementListRequest {
  FilterStartDate?: Date | string | null
  FilterEndDate?: Date | string | null
  State?: boolean | null
}

export interface IExcelAnnouncementRowFilter {
  GroupBy: ExcelAnnouncementRowGroupBy
  AnnouncementId?: number | null
  FileId?: number | null
  DealerCode?: string | null
  Page?: number
  PageSize?: number
}

/** Atlanan Excel satırı. */
export interface IExcelAnnouncementInvalidRow {
  RowNumber: number
  RawDealerCode: string
  Error: number
  ErrorText: string
}

export interface IExcelAnnouncementFile {
  Id: number
  AnnouncementId: number
  FileName: string
  FilePath: string
  DownloadUrl: string
  HasHeaderRow: boolean
  TotalRowCount: number
  InvalidRowCount: number
  UploadedUserName: string
  UploadedDate: Date
  InvalidRows: IExcelAnnouncementInvalidRow[]
}

export interface IExcelAnnouncement {
  Id: number
  Topic: string
  DescriptionTemplate: string
  StartDate: Date
  EndDate: Date
  Enable: boolean
  RepeatMode: ExcelAnnouncementRepeatMode
  GroupMode: ExcelAnnouncementGroupMode
  ImagePosition: ExcelAnnouncementImagePosition
  ShowGuaranteeLetters: boolean
  Image?: string
  ImageUrl?: string
  CreatedUserName?: string
  CreatedDate: Date
  UpdatedDate?: Date
  TotalRowCount: number
  InvalidRowCount: number
  DealerCount: number
  Files: IExcelAnnouncementFile[]
}

/** Bayinin popup'ta göreceği çözümlenmiş satır. */
export interface IExcelAnnouncementRow {
  Id: number
  AnnouncementId: number
  FileId: number
  FileName: string
  RowNumber: number
  DealerCode: string
  DealerName?: string
  Topic: string
  Description: string
}

export interface IExcelAnnouncementRowGroup {
  Key: string
  Label: string
  SubLabel?: string
  RowCount: number
}

/** Yükleme sonucu raporu. */
export interface IExcelAnnouncementImportReport {
  AnnouncementId: number
  FileId: number
  SavedRowCount: number
  InvalidRowCount: number
  DealerCount: number
  Columns: string[]
  MissingColumns: string[]
  InvalidRows: IExcelAnnouncementInvalidRow[]
}
